import request from './axios'

/**
 * 获取收发货配置列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.pageSize - 每页条数
 * @param {number} [params.status] - 状态：1启用，0禁用
 * @param {number} [params.type] - 地址类型：1发货地址，2退货地址
 * @param {string} [params.keyword] - 搜索关键词
 * @returns {Promise}
 */
export function getExpressSettings(params) {
  return request({
    url: '/manage/express-settings',
    method: 'get',
    params
  })
}

/**
 * 获取收发货配置详情
 * @param {number} id - 配置ID
 * @returns {Promise}
 */
export function getExpressSettingDetail(id) {
  return request({
    url: `/manage/express-settings/${id}`,
    method: 'get'
  })
}

/**
 * 创建收发货配置
 * @param {Object} data - 配置数据
 * @param {string} data.company_name - 公司名称
 * @param {string} data.name - 联系人姓名
 * @param {string} data.mobile - 联系人手机号
 * @param {string} data.province - 省份
 * @param {string} data.city - 城市
 * @param {string} data.district - 区县
 * @param {string} data.address - 详细地址
 * @param {number} data.status - 状态：1启用，0禁用
 * @param {number} data.type - 地址类型：1发货地址，2退货地址
 * @returns {Promise}
 */
export function createExpressSetting(data) {
  return request({
    url: '/manage/express-settings',
    method: 'post',
    data
  })
}

/**
 * 更新收发货配置
 * @param {number} id - 配置ID
 * @param {Object} data - 配置数据
 * @returns {Promise}
 */
export function updateExpressSetting(id, data) {
  return request({
    url: `/manage/express-settings/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除收发货配置
 * @param {number} id - 配置ID
 * @returns {Promise}
 */
export function deleteExpressSetting(id) {
  return request({
    url: `/manage/express-settings/${id}`,
    method: 'delete'
  })
}
